export default __webpack_public_path__ + "static/media/T-Spark.2d9f2f4a.png";